'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _faker = require('faker');

var _faker2 = _interopRequireDefault(_faker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Fake = function () {
  function Fake() {
    'ngInject';

    _classCallCheck(this, Fake);

    this.cars = [{ make: 'BMW', model: '5 Series' }, { make: 'Acura', model: 'MDX' }, { make: 'Volvo', model: 'S80' }, { make: 'Kia', model: 'Sorento' }, { make: 'Buick', model: 'Regal' }, { make: 'Jeep', model: 'Liberty' }];
    this.colors = ['Red', 'Green', 'Blue', 'Black', 'Silver', 'Orange', 'Gold'];

    this.getRandom = function (list) {
      return list[Math.floor(Math.random() * list.length)];
    };
  }

  _createClass(Fake, [{
    key: 'fakeApp',
    value: function fakeApp() {
      var car = this.getRandom(this.cars);
      var application = {
        name: {
          first: _faker2.default.name.firstName(),
          last: _faker2.default.name.lastName(),
          alt: _faker2.default.name.lastName()
        },
        contact: {
          email: _faker2.default.internet.email(),
          primaryPhone: _faker2.default.phone.phoneNumberFormat().replace(/-/g, ''),
          cellPhone: _faker2.default.phone.phoneNumberFormat().replace(/-/g, '')
        },
        address: {
          line1: _faker2.default.address.streetAddress(),
          line2: _faker2.default.address.secondaryAddress(),
          city: _faker2.default.address.city(),
          state: _faker2.default.address.stateAbbr(),
          zip: _faker2.default.address.zipCode()
        },
        beach: {
          name: '12',
          owner: _faker2.default.name.findName(),
          walk: _faker2.default.address.streetAddress(),
          phone: _faker2.default.phone.phoneNumberFormat().replace(/-/g, '')
        },
        vehicle: {
          year: _faker2.default.date.past().getFullYear(),
          make: car.make,
          model: car.model,
          color: this.getRandom(this.colors),
          size: 'Oversized',
          plate: _faker2.default.lorem.word().toUpperCase(),
          card: Math.floor(Math.random() * (9999 - 199 + 1)),
          state: _faker2.default.address.stateAbbr()
        },
        agreement: true
      };
      return application;
    }
  }]);

  return Fake;
}();

exports.default = Fake;


// WEBPACK FOOTER //
// ./client/components/services/fake.service.js